import React, {Component} from 'react'
import ActionDeleteModal from './ActionDeleteModal'

class ActionDelete extends Component {
    state = {
        isOpen: false,
    }

    _handleToggleModal = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        })
    }

    render() {
        const {isOpen} = this.state

        return <span>
            <i onClick={this._handleToggleModal} className="icon-bin text-danger"/>
            {
                isOpen && (
                    <ActionDeleteModal {...this.props} isOpen={isOpen}
                                       onToggleModal={this._handleToggleModal}/>
                )
            }
                            </span>
    }
}

export default ActionDelete